import * as React from 'react';
import { useMergeClasses, useTheme } from '../../../../../theme';
import cn from 'classnames';
import { List, CdnIcon, QntBadge } from '@shared/ui';
import { useToggleable } from '../../../../../hooks';
import Dropdown from '../../../../../Dropdown';
const FILTER_IGNORE_OUTSIDE_CLASS = 'filter-ignore-outside';
const Filter = ({ 
/* Base props */
classes, name, quantity, icon, variant = 'click', size = 'small', color = 'white', isSelected, isDisabled, 
/* Click props */
label, onClick, 
/* Dropdown props */
value, options, onChange }) => {
    const { Filter: defaultClasses } = useTheme('Shared');
    const theme = useMergeClasses(defaultClasses, classes);
    const { isOpen, close, toggle } = useToggleable(false);
    const isClick = variant === 'click';
    const isDropdown = variant === 'dropdown';
    const quantityElement = typeof quantity === 'number' ? React.createElement(QntBadge, { classes: { badge: theme.quantity }, count: quantity }) : null;
    const handleClick = () => {
        isClick ? onClick() : toggle();
    };
    return (React.createElement("div", { className: cn(theme.root, theme[size], theme[color], {
            [theme.selected]: isSelected,
            [theme.disabled]: isDisabled,
            [theme.dropdown]: isDropdown,
            [theme.clickable]: onClick || isDropdown
        }, FILTER_IGNORE_OUTSIDE_CLASS), onClick: handleClick },
        !!name && React.createElement("div", { className: theme.name }, name),
        isClick && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: theme.label }, label),
            quantityElement)),
        isDropdown && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: theme.value }, value.label),
            quantityElement,
            React.createElement(CdnIcon, { className: cn(theme.arrowIcon, { [theme.open]: isOpen }), icon: "Arrow/Drop_down" }),
            React.createElement(Dropdown, { isOpen: isOpen, onClose: close, outsideClickIgnoreClass: FILTER_IGNORE_OUTSIDE_CLASS },
                React.createElement("div", { className: theme.listWrapper },
                    React.createElement(List, { options: options, value: value, onChange: onChange }))))),
        icon && React.createElement("div", { className: theme.icon }, icon)));
};
export default Filter;
